class CartDrawer extends HTMLElement {
  constructor() {
    super()
    this.close = this.close.bind(this)
    this.setHeaderCartIconAccessibility()
  }
  connectedCallback() {
    this.handleOverlayClick = this.handleOverlayClick.bind(this)
    this.handleKeyup = (evt) => evt.code === 'Escape' && this.close()
    this.addEventListener('click', this.handleOverlayClick)
    this.addEventListener('keyup', this.handleKeyup)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleOverlayClick)
    this.removeEventListener('keyup', this.handleKeyup)
  }

  handleOverlayClick(evt) {
    if (evt.target.id === 'CartDrawer-Overlay') {
      this.close()
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble')
    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', (event) => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  open(triggeredBy, showCartItems = false) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote)

    this.setAttribute('data-open', '')
    let containerToTrapFocusOn = null
    const cartDrawerWrapper = document.querySelector('cart-drawer')
    const cartFooter = document.getElementById('main-cart-footer')
    if (showCartItems) {
      containerToTrapFocusOn = document.getElementById('CartDrawer__Dialog')
      cartDrawerWrapper.removeAttribute('data-empty')
    } else {
      containerToTrapFocusOn =
        this.getAttribute('data-empty') === 'true'
          ? this.querySelector('[data-cart-inner-empty]')
          : document.getElementById('CartDrawer__Dialog')
    }
    if (containerToTrapFocusOn) {
      const focusElement =
        containerToTrapFocusOn.querySelector('[data-cart-inner]') ||
        containerToTrapFocusOn.querySelector('[data-cart-close]')
      trapFocus(containerToTrapFocusOn, focusElement)
    }

    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.removeAttribute('data-open')
    removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button')
    cartDrawerNote.setAttribute('aria-expanded', 'false')

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      )
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      )
    })

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape)
  }

  renderContents(parsedState) {
    this.productId = parsedState.id

    if (parsedState.sections) {
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id)
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        )
      })
    }

    setTimeout(() => this.open())
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer__Dialog',
      },
      {
        id: 'cart-icon-bubble',
      },
    ]
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const cartPageItems = document.querySelector('cart-items')

    const sections = [
      {
        id: 'CartDrawer__Dialog',
        section: 'cart-drawer',
        selector: '[data-cart-inner]',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]

    if (cartPageItems) {
      cartPageItems.getSectionsToRender().forEach((section) => {
        if (!sections.find((item) => item.section === section.section)) {
          sections.push(section)
        }
      })
    }

    return sections
  }
}

customElements.define('cart-drawer-items', CartDrawerItems)
